import { z } from 'zod';
import { CaseIdSchema, ImportJobIdSchema, IsoTimestampSchema, SourceIdSchema } from './common.js';

export const ImportJobStatusSchema = z.enum(['queued', 'running', 'completed', 'failed']);
export type ImportJobStatus = z.infer<typeof ImportJobStatusSchema>;

/**
 * Importjobb – dokumenterer beviskjeden (§14) for en importoperasjon.
 * Inkluderer parser-navn og versjon slik at importen kan etterprøves.
 */
export const ImportJobSchema = z.object({
  id: ImportJobIdSchema,
  caseId: CaseIdSchema,
  sourceId: SourceIdSchema,
  status: ImportJobStatusSchema,
  /** Fremgang 0–100 (prosent) */
  progress: z.number().int().min(0).max(100).optional(),
  startedAt: IsoTimestampSchema.optional(),
  finishedAt: IsoTimestampSchema.optional(),
  /** Feilmelding ved status "failed" */
  error: z.string().optional(),
  /** Navn på parseren som behandlet kilden, f.eks. "pst-parser" */
  parserName: z.string().optional(),
  /** Versjon av parseren – muliggjør etterprøvbarhet av beviskjede */
  parserVersion: z.string().optional(),
});

export type ImportJob = z.infer<typeof ImportJobSchema>;
